export default function codeFormat(value: string | undefined, upperCase = false): string {
  let result = ''
  if (value) {
    const regexp = /0*(\d+)/
    const regResult = regexp.exec(value)

    if (regResult) {
      result = regResult[1]
    }
  }

  if (upperCase) {
    result = result.toUpperCase()
  }

  return result
}
